import { getKey } from '~/utils/helpers'

export const CONFIG = {
  baseUrl: (env, type = 'default') => {
    return getKey(type, {
      default: getKey(env, {
        develop: 'https://dev.api.compareclub.com.au',
        staging: 'https://staging.api.compareclub.com.au',
        production: 'https://api.compareclub.com.au',
        sit: 'https://sit.api.compareclub.com.au'
      }),

      alternativemedia: getKey(env, {
        develop: 'https://dev.api.alternativemedia.com.au',
        staging: 'https://staging.api.alternativemedia.com.au',
        production: 'https://api.alternativemedia.com.au',
        sit: 'https://sit.api.alternativemedia.com.au'
      }),

      memberhub: getKey(env, {
        develop: 'https://dev.api.compareclub.com.au/memberhub',
        staging: 'https://staging.api.compareclub.com.au/memberhub',
        production: 'https://api.compareclub.com.au/memberhub',
        sit: 'https://sit.api.compareclub.com.au/memberhub'
      }),

      utilities: getKey(env, {
        develop: 'https://dev.utilities-backend.compareclub.com.au',
        staging: 'https://stg.utilities-backend.compareclub.com.au',
        production: 'https://utilities-backend.compareclub.com.au',
        sit: 'https://sit.utilities-backend.compareclub.com.au'
      }),

      travel: getKey(env, {
        develop: 'https://dev.travel-backend.compareclub.com.au',
        staging: 'https://stg.travel-backend.compareclub.com.au',
        production: 'https://travel-backend.compareclub.com.au',
        sit: 'https://stg.travel-backend.compareclub.com.au'
      }),

      tokenization: getKey(env, {
        develop: 'https://dev.pci-tokenex-backend.compareclub.com.au',
        staging: 'https://stg.pci-tokenex-backend.compareclub.com.au',
        production: 'https://pci-tokenex-backend.compareclub.com.au',
        sit: 'https://sit.pci-tokenex-backend.compareclub.com.au'
      }),

      partnerOrder: getKey(env, {
        develop: 'https://dev.partner-backend.compareclub.com.au',
        staging: 'https://stg.partner-backend.compareclub.com.au',
        production: 'https://partner-backend.compareclub.com.au',
        sit: 'https://sit.partner-backend.compareclub.com.au'
      }),

      // Deployed Nuxt web origin — the host where Nitro server routes (`/api/*`)
      // actually run. Used by the Capacitor app build (which has no Nitro of
      // its own) to proxy `/api/*` calls back to the website.
      web: getKey(env, {
        develop: 'https://develop.compareclub.com.au',
        staging: 'https://uat.compareclub.com.au',
        production: 'https://compareclub.com.au'
      }),

      // OTTO AI energy advisor backend (apps/api), reached server-side only by
      // the Nitro BFF proxy (server/api/otto/*). Endpoints `/chat/stream` and
      // `/bills/upload`. Server-only fallback when NUXT_OTTO_INTERNAL_URL is
      // unset; should be the INTERNAL ALB DNS (OTTO is not public). NOTE: hosts
      // below are placeholders — confirm the real per-env internal hosts.
      otto: getKey(env, {
        develop: 'https://dev.otto-backend.compareclub.com.au',
        staging: 'https://stg.otto-backend.compareclub.com.au',
        production: 'https://otto-backend.compareclub.com.au',
        sit: 'https://sit.otto-backend.compareclub.com.au'
      })
    })
  },
  // Retrieve the API Key based on the associated vertical from the env
  getApiKey: (vertical = 'HealthInsurance') => {
    const env = useRuntimeConfig()

    const APIKEY = {
      Default: env.apikeyHealthInsurance,
      HealthInsurance: env.apikeyHealthInsurance,
      LifeInsurance: env.apikeyLifeInsurance,
      IncomeProtection: env.apikeyIncomeProtection,
      Energy: env.apikeyEnergy,
      OVHC: env.apikeyOvhcInsurance,
      CarInsurance: env.apikeyCarInsurance,
      HomeLoans: env.apikeyHomeLoans,
      HomeLoanForm: env.apikeyHomeLoans,
      Email: env.apikeyEmail,
      CompareClub: env.apikeyCompareclub,
      ReCaptcha: env.apikeyRecaptcha,
      PartnerNewClient: env.apikeyPartnerNewClient,
      PersonalLoans: env.apikeyPersonalLoans,
      Utilities: env.apikeyUtilities,
      TravelInsurance: env.apikeyTravelInsurance,
      Tokenization: env.apikeyTokenization
    }

    return APIKEY[vertical]
  }
}
